import styled from "styled-components";

const RatingBar = ({ value = 0, max = 100 }) => {
  const percentage = Math.min(Math.max((value / max) * 100, 0), 100);

  return (
    <StyledWrapper>
      <div className="rating_display">
        <div className="bar_bg">
          <div
            className="bar_fill"
            style={{ width: `${percentage}%` }}
          />
        </div>
        <div>{percentage}%</div>
      </div>
    </StyledWrapper>
  );
};

const StyledWrapper = styled.div`
  .rating_display {
    display: flex;
    align-items: center;
    height: 30px; /* matches star font-size */
    width: 250px; /* roughly same visual weight as 5 stars */
    gap: 1rem;
  }

  .bar_bg {
    width: 100%;
    height: 10px; /* slim, like a UI indicator */
    background: rgba(120, 160, 255, 0.25);
    border-radius: 999px;
    overflow: hidden;
  }

  .bar_fill {
    height: 100%;
    background: linear-gradient(
      90deg,
      #4f7cff,
      #6fa8ff
    );
    border-radius: 999px;
    transition: width 0.25s ease;
  }
`;

export default RatingBar;
